// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LogNewTransferModal_EntityFragment = { __typename?: 'Entity', id: string, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } };

export type LogNewTransferModal_ClientOrganizationFragment = { __typename?: 'ClientOrganization', id: string, name: string, kind?: Types.ClientOrganizationKind | null };

export type LogNewTransferModal_HouseholdFragment = { __typename?: 'Household', id: string, possiblePrimaryClients: Array<{ __typename?: 'ClientProfile', id: string, displayName: string }>, clientOrganizations?: Array<(
    { __typename?: 'ClientOrganization' }
    & LogNewTransferModal_ClientOrganizationFragment
  )> | null, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & LogNewTransferModal_EntityFragment
      ) | null } | null> | null } };

export type LogNewTransferModalQueryVariables = Types.Exact<{
  entityId: Types.Scalars['ID']['input'];
  transferId: Types.Scalars['ID']['input'];
  hasTransferId: Types.Scalars['Boolean']['input'];
}>;


export type LogNewTransferModalQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, kind: Types.EntityKind, household: (
          { __typename?: 'Household', id: string }
          & LogNewTransferModal_HouseholdFragment
        ) } | null } | null> | null }, loggedTransfers?: { __typename?: 'LoggedTransferConnection', edges?: Array<{ __typename?: 'LoggedTransferEdge', node?: { __typename?: 'LoggedTransfer', id: string, transactionDate: Time, amount: CurrencyUSD, purpose?: Types.LoggedTransferPurpose | null, otherPurposeDescription?: string | null, sourceEntity?: { __typename?: 'Entity', id: string } | null, sourceGrantor?: { __typename?: 'ClientProfile', id: string } | null, sourceOrganization?: { __typename?: 'ClientOrganization', id: string } | null, receivingEntity?: { __typename?: 'Entity', id: string } | null, receivingGrantor?: { __typename?: 'ClientProfile', id: string } | null, receivingOrganization?: { __typename?: 'ClientOrganization', id: string } | null } | null } | null> | null } };

export const Operations = {
  Query: {
    LogNewTransferModal: 'LogNewTransferModal' as const
  },
  Fragment: {
    LogNewTransferModal_Entity: 'LogNewTransferModal_Entity' as const,
    LogNewTransferModal_ClientOrganization: 'LogNewTransferModal_ClientOrganization' as const,
    LogNewTransferModal_Household: 'LogNewTransferModal_Household' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const LogNewTransferModal_ClientOrganizationFragmentDoc = gql`
    fragment LogNewTransferModal_ClientOrganization on ClientOrganization {
  id
  name
  kind
}
    `;
export const LogNewTransferModal_EntityFragmentDoc = gql`
    fragment LogNewTransferModal_Entity on Entity {
  id
  kind
  subtype {
    id
    displayName
  }
}
    `;
export const LogNewTransferModal_HouseholdFragmentDoc = gql`
    fragment LogNewTransferModal_Household on Household {
  id
  possiblePrimaryClients {
    id
    displayName
  }
  clientOrganizations {
    ...LogNewTransferModal_ClientOrganization
  }
  entities {
    edges {
      node {
        ...LogNewTransferModal_Entity
      }
    }
  }
}
    ${LogNewTransferModal_ClientOrganizationFragmentDoc}
${LogNewTransferModal_EntityFragmentDoc}`;
export const LogNewTransferModalDocument = gql`
    query LogNewTransferModal($entityId: ID!, $transferId: ID!, $hasTransferId: Boolean!) {
  entities(where: {id: $entityId}) {
    edges {
      node {
        id
        kind
        household {
          id
          ...LogNewTransferModal_Household
        }
      }
    }
  }
  loggedTransfers(where: {id: $transferId}) @include(if: $hasTransferId) {
    edges {
      node {
        id
        sourceEntity {
          id
        }
        sourceGrantor {
          id
        }
        sourceOrganization {
          id
        }
        receivingEntity {
          id
        }
        receivingGrantor {
          id
        }
        receivingOrganization {
          id
        }
        transactionDate
        amount
        purpose
        otherPurposeDescription
      }
    }
  }
}
    ${LogNewTransferModal_HouseholdFragmentDoc}`;

/**
 * __useLogNewTransferModalQuery__
 *
 * To run a query within a React component, call `useLogNewTransferModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogNewTransferModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogNewTransferModalQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      transferId: // value for 'transferId'
 *      hasTransferId: // value for 'hasTransferId'
 *   },
 * });
 */
export function useLogNewTransferModalQuery(baseOptions: Apollo.QueryHookOptions<LogNewTransferModalQuery, LogNewTransferModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogNewTransferModalQuery, LogNewTransferModalQueryVariables>(LogNewTransferModalDocument, withFetchPolicyContext(options));
      }
export function useLogNewTransferModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogNewTransferModalQuery, LogNewTransferModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogNewTransferModalQuery, LogNewTransferModalQueryVariables>(LogNewTransferModalDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useLogNewTransferModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LogNewTransferModalQuery, LogNewTransferModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LogNewTransferModalQuery, LogNewTransferModalQueryVariables>(LogNewTransferModalDocument, withFetchPolicyContext(options));
        }
export type LogNewTransferModalQueryHookResult = ReturnType<typeof useLogNewTransferModalQuery>;
export type LogNewTransferModalLazyQueryHookResult = ReturnType<typeof useLogNewTransferModalLazyQuery>;
export type LogNewTransferModalSuspenseQueryHookResult = ReturnType<typeof useLogNewTransferModalSuspenseQuery>;
export type LogNewTransferModalQueryResult = Apollo.QueryResult<LogNewTransferModalQuery, LogNewTransferModalQueryVariables>;